<template>
  <div class="why">
    <div class="section">
      <h2>Web Development</h2>
      <p>
        I excel in building dynamic and responsive web applications using PHP, JavaScript, HTML, and CSS. From
        e-commerce sites to content management systems, I bring websites to life.
      </p>
    </div>
    <div class="section">
      <h2>Database Management</h2>
      <p>
        I have a strong command of SQL for efficient database design and management. This ensures that data is stored
        and retrieved smoothly, enhancing the functionality of web applications.
      </p>
    </div>
    <div class="section">
      <h2>Problem Solving</h2>
      <p>
        As a developer, I have a knack for tackling complex problems. I enjoy breaking down challenges, finding
        efficient solutions, and optimizing code for performance.
      </p>
    </div>
    <div class="section">
      <h2>User-Focused Design</h2>
      <p>
        I prioritize creating user-friendly and aesthetically pleasing interfaces. My work aims to provide a seamless
        and enjoyable experience for website visitors.
      </p>
    </div>
    <div class="section">
      <h2>Collaboration</h2>
      <p>
        I work well in teams, and I'm able to communicate technical concepts to non-technical stakeholders. This helps
        bridge the gap between development and project requirements.
      </p>
    </div>
    <div class="section">
      <h2>Quality Assurance</h2>
      <p>
        I'm meticulous about testing and quality assurance to ensure the reliability and security of web applications.
        This includes addressing vulnerabilities and ensuring data protection.
      </p>
    </div>
  </div>
</template>

<style scoped>
.why {
  background-color: #007bff;
  color: #fff;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(2, minmax(300px, 1fr));
  gap: 20px;
}

/* Media query for smaller screens */
@media screen and (max-width: 768px) {
  .why {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Media query for even smaller screens */
@media screen and (max-width: 480px) {
  .why {
    grid-template-columns: 1fr;
  }
}

.section {
  background-color: #fff;
  color: #333;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.section h2 {
  margin-top: 0;
}

.section p {
  margin-bottom: 0;
}
</style>

<script setup>
</script>
